<template>
  <div class="video-bg-container">
    <!-- 视频背景（无任何控件） -->
    <!-- <video 
      class="bg-video"
      v-if="src!=''"
      :src="src"  
      autoplay                            
      muted                              
      loop                                 
      playsinline                         
      preload="auto"                   
    ></video> -->
    <img :src="src" style="width:100%;height: 100%;object-fit: cover;"></img>
    <!-- 页面内容（在视频上方） -->
    <div class="page-content">
      <p style="font-size: 50px; -webkit-text-stroke:1px black;font-style:italic ">快乐星姬天制作委员会</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoBackground',
  data() {
    return {
       src:""
    }
  },
  created() {
	  var num = Math.floor(Math.random() * 8) + 1;
    this.src="https://image.begonia.cafe/tx/bg/"+num+".webp"
  },
}
</script>

<style scoped>
.video-bg-container {
  position: relative;  /* 作为内容的定位容器 */
  width: 100%;        /* 全屏宽度 */
  height: 100%;       /* 全屏高度 */
  overflow: hidden;    /* 隐藏超出容器的部分 */
}

/* 视频背景样式 */
.bg-video {
  position: absolute;  /* 脱离文档流，覆盖容器 */
  top: 0;
  left: 0;
  width: 100%;         /* 宽度铺满 */
  height: 100%;        /* 高度铺满 */
  object-fit: cover;   /* 保持比例并覆盖整个容器（避免黑边） */
  z-index: -1;         /* 置于底层，确保内容在上方 */
  /* 隐藏所有默认控件（浏览器原生控件） */
  pointer-events: none; /* 禁止点击交互（避免触发控件） */
}

/* 页面内容样式 */
.page-content {
  position: relative;  /* 相对于容器定位 */
  z-index: 1;          /* 置于视频上方 */
  color: white;        /* 文字颜色（确保在视频上可见） */
  padding: 20px;
  text-align: center;
}
</style>